<template>
    <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
    >
        <rect x="3" y="4" width="18" height="4"></rect>
        <path d="M5 8v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8"></path>
        <path d="M10 12h4"></path>
    </svg>
</template>
